/** True when Quill/HTML content has no visible text. */
export const isEmptyHtml = (html) => {
  const raw = String(html || '').trim();
  if (!raw) return true;
  const stripped = raw
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return !stripped;
};

const escapeHtml = (text) => String(text)
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;');

/** Normalize stored feature text for Quill (wrap legacy plain text in a paragraph). */
export const toEditorHtml = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return '';
  if (/<[a-z][\s\S]*>/i.test(raw)) return raw;
  return `<p>${escapeHtml(raw)}</p>`;
};

/** Plain-text preview for grids and labels. */
export const stripHtml = (html) => {
  const raw = String(html || '');
  if (!raw.trim()) return '';

  if (typeof document !== 'undefined') {
    const div = document.createElement('div');
    div.innerHTML = raw;
    return (div.textContent || div.innerText || '').replace(/\s+/g, ' ').trim();
  }

  return raw.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
};
